/**
 * Tutorial guidato delle impostazioni Notifiche push.
 *
 * Un preparativo solo: il riquadro della configurazione, che il passo dedicato apre
 * per mostrarne i campi. `stopNotificationsSettingsTour` lo richiude a fine giro, e
 * solo se ad aprirlo e' stato il tutorial. L'interruttore non si tocca.
 */
const SCOPE = '[data-tour-scope="setting-notifications"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

let opened = false;

const visible = selector => {
	const element = document.querySelector(selector);

	return !!element && element.getClientRects().length > 0;
};

/** Apre il riquadro della configurazione, se non e' gia' aperto. */
function openFirst() {
	if (visible(at('settings'))) return;

	const toggle = document.querySelector(at('expand'));

	if (toggle) {
		opened = true;
		toggle.click();
	}
}

/** Richiude il riquadro aperto dal tutorial. */
export function stopNotificationsSettingsTour() {
	if (!opened) return;

	opened = false;

	if (visible(at('settings'))) {
		document.querySelector(at('expand'))?.click();
	}
}

export function createNotificationsSettingsTourSteps() {
	return [
		{
			body: "Qui si collega Firebase, il servizio di Google che consegna le notifiche push ai dispositivi. E' il motore dietro la pagina Notifiche push: li' si scrive il messaggio, qui si da' al gestionale il modo di recapitarlo.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Il motore delle push',
		},
		{
			body: "L'interruttore accende il servizio e salva subito. Spento, la pagina di invio resta utilizzabile ma le notifiche non partono: chi le aspetta non riceve niente e nessuno se ne accorge finche' non si guarda lo storico.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Accendere il servizio',
		},
		{
			body: "Il piu' a inizio riga apre la configurazione. Il pezzo forte e' il file JSON delle credenziali del service account, che si scarica dalla console di Firebase: da li' il gestionale prende il diritto di mandare notifiche a nome della tua app.",
			before: stopNotificationsSettingsTour,
			key: 'expand',
			placement: 'right',
			target: at('expand'),
			timeout: 400,
			title: 'Aprire la configurazione',
		},
		{
			body: "Dentro il riquadro le piattaforme sono tre e vogliono cose diverse: per il web serve il certificato VAPID, per iOS l'identificativo dell'app e le chiavi APNs, per Android il nome del pacchetto. Quello che lasci vuoto e' la piattaforma su cui le notifiche non arriveranno - ed e' l'errore piu' comune quando funzionano su un dispositivo e non sull'altro.",
			before: openFirst,
			key: 'settings',
			placement: 'right',
			target: at('settings'),
			timeout: 600,
			title: 'Web, iOS e Android',
		},
	];
}
